var $ = jQuery;

jQuery(function($) {

    $('<h3 class="fl-cta-title">Get That Clean Nose Feeling<sup>®</sup></h3>')
        .insertBefore('.newsletter-section');

    if (window.location.href.includes("neilmed-piercing-aftercare")) {
        $('#main-collection-product-grid li:eq(1) .card__inner').append('<img src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/NEW-Icon_256x256_crop_center.png" class="new-sticker new-pac-sticker" alt="New">');
        $('#main-collection-product-grid li:eq(2) .card__inner').append('<img src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/NEW-Icon_256x256_crop_center.png" class="new-sticker new-pac-sticker" alt="New">');
        $('#main-collection-product-grid li:eq(3) .card__inner').append('<img src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/NEW-Icon_256x256_crop_center.png" class="new-sticker new-pac-sticker" alt="New">');
        $('#main-collection-product-grid li:eq(4) .card__inner').append('<img src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/NEW-Icon_256x256_crop_center.png" class="new-sticker new-pac-sticker" alt="New">');
    }

    $('.dual-product-launch #MainContent').prepend('<h1>New Product Launch!</h1>');

    if (window.location.href.indexOf("collections/nasal-aspirators") > -1) {
        $("#shopify-section-template--15303133888683__rich_text_YiiydP h2").hide();
    }

var targetHandle = 'neilmed-baby-nasakleen-nasal-aspirator';

// COLLECTION / GRID PAGES
$('.card-wrapper').each(function () {

    var $card = $(this);
    var productLink = $card.find('a[href*="/products/"]').first().attr('href');

    if (
        productLink &&
        productLink.indexOf('/products/' + targetHandle) !== -1
    ) {

        var $gridItem = $card.closest('.grid__item');

        if (!$gridItem.children('.top-choice').length) {
            $gridItem.append(
                '<img class="top-choice" src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/2026_BMC_Top_Choice.png" alt="Top Choice">'
            );
        }
    }

});

// SINGLE PRODUCT PAGE
if (window.location.pathname.indexOf('/products/' + targetHandle) !== -1) {

    var $mediaContainer = $('.product__media-wrapper').first();

    if (
        $mediaContainer.length &&
        !$mediaContainer.children('.top-choice-single-product').length
    ) {
        $mediaContainer.append(
            '<img class="top-choice-single-product" src="https://cdn.shopify.com/s/files/1/0601/4546/7563/files/2026_BMC_Top_Choice.png" alt="Top Choice">'
        );
    }

}

});

/***** ADA FIXES *****/

(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function replaceElementTag(oldEl, newTag) {
    if (!oldEl || !oldEl.parentNode) return null;

    const newEl = document.createElement(newTag);

    Array.from(oldEl.attributes).forEach(function (attr) {
      if (!(oldEl.tagName.toLowerCase() === "ul" && attr.name === "role")) {
        newEl.setAttribute(attr.name, attr.value);
      }
    });

    newEl.innerHTML = oldEl.innerHTML;
    oldEl.parentNode.replaceChild(newEl, oldEl);
    return newEl;
  }

  function addKeyboardClick(el) {
    if (!el || el.dataset.adaKeyBound === "true") return;

    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        el.click();
      }
    });

    el.dataset.adaKeyBound = "true";
  }

  function upgradeToButton(el, label, controls) {
    if (!el) return;

    el.setAttribute("role", "button");

    if (!el.hasAttribute("tabindex")) {
      el.setAttribute("tabindex", "0");
    }

    if (label && !el.hasAttribute("aria-label")) {
      el.setAttribute("aria-label", label);
    }

    if (controls) {
      el.setAttribute("aria-controls", controls.replace(/^#/, ""));
    }

    if (!el.hasAttribute("aria-expanded")) {
      el.setAttribute("aria-expanded", "false");
    }

    addKeyboardClick(el);
  }

  function removeInvalidTabSemantics() {
    document.querySelectorAll('[role="tablist"]').forEach(function (el) {
      el.removeAttribute("role");
      el.removeAttribute("aria-multiselectable");
    });

    document.querySelectorAll('[role="tab"]').forEach(function (el) {
      el.removeAttribute("role");
      el.removeAttribute("aria-selected");
      el.removeAttribute("aria-controls");
      el.removeAttribute("tabindex");
    });

    document.querySelectorAll('[role="tabpanel"]').forEach(function (el) {
      el.removeAttribute("role");
      el.removeAttribute("aria-labelledby");
      el.removeAttribute("tabindex");
    });
  }

  function fixCollapseIcons() {
    document.querySelectorAll(".collapse-icon").forEach(function (toggle) {
      const tag = toggle.tagName.toLowerCase();

      const targetSelector =
        toggle.getAttribute("data-target") ||
        toggle.getAttribute("data-href") ||
        (toggle.getAttribute("href") && toggle.getAttribute("href").startsWith("#")
          ? toggle.getAttribute("href")
          : null);

      const target = targetSelector ? document.querySelector(targetSelector) : null;

      if (tag === "a") {
        toggle.setAttribute("role", "button");
        if (!toggle.hasAttribute("tabindex")) {
          toggle.setAttribute("tabindex", "0");
        }
      }

      if (target) {
        if (!target.id && targetSelector.startsWith("#")) {
          target.id = targetSelector.substring(1);
        }

        toggle.setAttribute("aria-controls", target.id);

        const expanded =
          toggle.getAttribute("aria-expanded") === "true" ||
          target.classList.contains("in") ||
          target.classList.contains("show");

        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      }

      if (!toggle.hasAttribute("aria-label")) {
        const container = toggle.closest(".panel-heading, .panel-title, li, .site-nav__link");
        if (container) {
          const textLink = container.querySelector("a[href]:not(.collapse-icon)");
          const labelText = textLink ? textLink.textContent.trim() : "";
          if (labelText) {
            toggle.setAttribute("aria-label", "Toggle " + labelText + " submenu");
          }
        }
      }

      addKeyboardClick(toggle);
    });
  }

  function syncExpandedState() {
    document.querySelectorAll(".collapse-icon").forEach(function (toggle) {
      const targetSelector =
        toggle.getAttribute("data-target") ||
        toggle.getAttribute("data-href") ||
        (toggle.getAttribute("href") && toggle.getAttribute("href").startsWith("#")
          ? toggle.getAttribute("href")
          : null);

      if (!targetSelector) return;

      const target = document.querySelector(targetSelector);
      if (!target) return;

      const expanded =
        target.classList.contains("in") ||
        target.classList.contains("show") ||
        toggle.classList.contains("active") ||
        !toggle.classList.contains("ishi-collapsed");

      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  function bindCollapseSync() {
    document.querySelectorAll(".collapse-icon").forEach(function (toggle) {
      if (toggle.dataset.adaClickBound === "true") return;

      toggle.addEventListener("click", function () {
        setTimeout(syncExpandedState, 50);
      });

      toggle.dataset.adaClickBound = "true";
    });
  }

  function fixButtons() {
    document.querySelectorAll("button").forEach(function (btn) {
      const text = btn.innerText.trim();
      const hasLabel = btn.getAttribute("aria-label") || btn.getAttribute("aria-labelledby");

      if (!text && !hasLabel) {
        if (btn.classList.contains("owl-next")) {
          btn.setAttribute("aria-label", "Next slide");
        } else if (btn.classList.contains("owl-prev")) {
          btn.setAttribute("aria-label", "Previous slide");
        } else if (btn.classList.contains("search")) {
          btn.setAttribute("aria-label", "Search");
        } else if (btn.classList.contains("close")) {
          btn.setAttribute("aria-label", "Close");
        } else {
          btn.setAttribute("aria-label", "Button");
        }
      }

      btn.removeAttribute("role");

      btn.querySelectorAll("i, svg").forEach(function (icon) {
        icon.setAttribute("aria-hidden", "true");
        icon.setAttribute("focusable", "false");
      });
    });

    document.querySelectorAll('button[aria-label="Button"]').forEach(function (btn) {
      const text = btn.textContent.trim();
      if (text) {
        btn.setAttribute("aria-label", text);
      } else {
        btn.removeAttribute("aria-label");
      }
    });
  }

  function fixCustomButtons() {
    document
      .querySelectorAll(
        '.product-popup-modal__button[aria-haspopup], .userinfo-title[aria-expanded]'
      )
      .forEach(function (el) {
        const text = el.textContent.trim();
        const target = el.getAttribute("data-href");
        upgradeToButton(el, text || "Open panel", target && target.startsWith("#") ? target : null);
      });

    document
      .querySelectorAll('p[data-action="ishi-panel"][aria-controls]')
      .forEach(function (el) {
        const text = el.textContent.trim();
        const controls = el.getAttribute("aria-controls");
        upgradeToButton(el, text || "Open panel", controls);
      });

    const searchToggle = document.querySelector("#_desktop_search .search-title");
    if (searchToggle) {
      upgradeToButton(searchToggle, "Open search", "search-container-full");
    }

    const cartToggle = document.querySelector("#_desktop_cart .cart-display");
    if (cartToggle) {
      upgradeToButton(cartToggle, "Open cart", "cart-notification");
    }
  }

  function fixInvalidProductMedia() {
    document.querySelectorAll("li.product__media-item.grid__item").forEach(function (li) {
      const parent = li.parentElement;
      if (!parent) return;

      const parentTag = parent.tagName.toLowerCase();
      if (parentTag !== "ul" && parentTag !== "ol") {
        replaceElementTag(li, "div");
      }
    });

    document.querySelectorAll(".owl-item > li").forEach(function (li) {
      replaceElementTag(li, "div");
    });

    const mainMediaUl = document.querySelector("ul#main-media-container.single-product");
    if (mainMediaUl) {
      const hasInvalidDivChild = Array.from(mainMediaUl.children).some(function (child) {
        return child.tagName && child.tagName.toLowerCase() === "div";
      });

      if (hasInvalidDivChild) {
        replaceElementTag(mainMediaUl, "div");
      }
    }

    document.querySelectorAll("ul.product__media-list.owl-carousel").forEach(function (ul) {
      replaceElementTag(ul, "div");
    });

    document.querySelectorAll("ul").forEach(function (ul) {
      const hasInvalidDivChild = Array.from(ul.children).some(function (child) {
        return (
          child.tagName &&
          child.tagName.toLowerCase() === "div" &&
          child.classList.contains("product__media-item")
        );
      });

      if (hasInvalidDivChild) {
        replaceElementTag(ul, "div");
      }
    });

    document.querySelectorAll(".product__media-list > li").forEach(function (li) {
      const parent = li.parentElement;
      if (!parent) return;

      if (parent.tagName.toLowerCase() !== "ul" && parent.tagName.toLowerCase() !== "ol") {
        replaceElementTag(li, "div");
      }
    });
  }

  function runAllFixes() {
    removeInvalidTabSemantics();
    fixCollapseIcons();
    syncExpandedState();
    bindCollapseSync();
    fixButtons();
    fixCustomButtons();
    fixInvalidProductMedia();
  }

  onReady(function () {
    runAllFixes();

    const observer = new MutationObserver(function () {
      runAllFixes();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(runAllFixes, 300);
    setTimeout(runAllFixes, 1000);
    setTimeout(runAllFixes, 2000);
  });
})();

/***** Product Variant Price Fix *****/

document.addEventListener('DOMContentLoaded', function () {
  const productDataEl = document.getElementById('ProductJson-{{ section.id }}');
  if (!productDataEl) return;

  const productData = JSON.parse(productDataEl.textContent);
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateDisplayedPrice(variantId) {
    const variant = productData.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    const priceEls = document.querySelectorAll(
      '.price .price-item--regular, .price__regular .price-item--regular, .price-item--sale, .price__sale .price-item--sale'
    );

    priceEls.forEach(function (el) {
      el.textContent = formatMoney(variant.price);
    });

    const compareEls = document.querySelectorAll('.price-item--compare');
    compareEls.forEach(function (el) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  form.addEventListener('change', function () {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      updateDisplayedPrice(idInput.value);
    }
  });

  const idInput = form.querySelector('input[name="id"]');
  if (idInput && idInput.value) {
    updateDisplayedPrice(idInput.value);
  }
});